import { stringToSha256 } from './crypto'

export function encryptEmail(email: string) {
  return stringToSha256(email.toLowerCase().replace(/\+[^@]*@/, '@'))
}
